<template>
  <div class="container pb-5">
    <div class="font-weight-bold">
      <h2 class="calc-title text-uppercase">{{ $t('calcResult') }}</h2>
      <div class="row">
        <div class="col-md-6 col-12">
          {{ $t('calcLabelCurrency') }} {{ calcForm.currency }}
        </div>
        <div class="col-md-6 col-12">
          {{ $t('calcLabelInvestment') }} {{ calcForm.amount | displayAmount }}
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6 col-12">
          {{ $t('calcLabelPeriod') }} {{ calcForm.timePeriod }} tahun
        </div>
        <div class="col-md-6 col-12">
          {{ $t('calcLabelStartDate') }} {{ calcForm.investmentDate | moment("D MMMM YYYY") }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="card text-center">
            <div class="card-body">
              <p>{{ $t('calcInterestTotal') }} {{ calcForm.timePeriod }} {{ $t('year') }}</p>
              <h2>{{ calcResult.totalInterest | displayAmount(calcResult.totalInterest) }}</h2>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="card text-center">
            <div class="card-body">
              <p>{{ $t('calcInvestmentTotal') }} + {{ $t('calcInterest') }} {{ calcForm.timePeriod }} {{ $t('year') }}</p>
              <h2>{{ calcResult.totalReturn | displayAmount(calcResult.totalReturn) }}</h2>
            </div>
          </div>
        </div>
      </div>
      <br />

      <!-- result -->
      <div v-for="(result, result_idx) in calcResult.interestDetail" :key="result.year" class="calc-result mb-5">
        <h1 class="text-center m-3">{{ result.year }}</h1>
        <div v-for="(quarter_detail, quarter_detail_idx) in result.detail" :key="quarter_detail.quarter" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <p class="quartile">{{ $t('calcQuarter') }} {{ quarter_detail.quarter }}
                  <br>
                  {{ quarter_detail.quarterDate | displayDate }}
                </p>
              </div>
              <div class="col-6">
                <p class="amount text-right">
                  {{ quarter_detail.interest | displayAmount(calcForm.currency) }}
                </p>
              </div>
            </div>
            <div class="row" v-if="result_idx == calcResultLastIdx && quarter_detail_idx == calcResultQuarterLastIdx">
              <div class="col-md-7 col-6 repayment">
                <p class="text-center">{{ $t('calcInvestmentReturn') }}</p>
              </div>
              <div class="col-md-3 offset-md-2 offset-md-1 col-6">
                <p class="amount text-right">{{ calcForm.amount | displayAmount(calcForm.currency) }}</p>
              </div>
            </div>
            <div class="row " v-if="result_idx == calcResultLastIdx && quarter_detail_idx == calcResultQuarterLastIdx">
              <div class="col-md-7 total col-6">
                <p class="m-0">TOTAL</p>
              </div>
              <div class="col-md-3 offset-md-2 col-6">
                <p class="amount text-right border-dark border-top pt-3">
                  {{ lastRepayment | displayAmount(calcForm.currency) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p>
      {{ $t('calcFooter1') }}
      <br>{{ $t('calcFooter2') }}
    </p>
    <button @click="openRegisterModal" type="submit" class="btn btn-yellow-custom">REGISTER</button>
  </div>
</template>

<script>
export default {
  name: 'CalculateResult',
  props: {
    calcForm: Object,
    calcResult: Object
  },
  data() {
    return {
      calcResultLastIdx: 0,
      calcResultQuarterLastIdx: 0,
      lastRepayment: 0
    }
  },
  methods: {
    openRegisterModal() {
      $("#registerModal").modal('show');
    }
  },
  watch: {
    calcResult: function(){
      let interestDetail = this.calcResult.interestDetail

      let calcResultLastIdx = interestDetail.length - 1;
      this.calcResultLastIdx = calcResultLastIdx

      let quarterLastIdx = interestDetail[calcResultLastIdx].detail.length - 1;
      this.calcResultQuarterLastIdx = quarterLastIdx;

      this.lastRepayment = interestDetail[calcResultLastIdx].detail[quarterLastIdx].interest + Number(this.calcForm.amount)
    }
  }
};
</script>

<style scoped>
.calc-result .repayment {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

@media (min-width: 992px) {
  .calc-result .amount {
    font-size: 30px;
    font-weight: normal;
  }
}

</style>